import { RenderersController } from "./poly/RenderersController";
import { PolyLibsController } from "./poly/PolyLibsController";
import {
  NodesRegister,
  OperationsRegister
} from "./poly/registers/nodes/NodesRegister";
import { ExpressionRegister } from "./poly/registers/expressions/ExpressionRegister";
import { AssemblersRegister } from "./poly/registers/assemblers/AssemblersRegistry";
import { PluginsRegister } from "./poly/registers/plugins/PluginsRegister";
import { PolyCamerasRegister } from "./poly/registers/cameras/PolyCamerasRegister";
import { BlobsController } from "./poly/BlobsController";
import { AssetUrlsController } from "./poly/AssetUrlsController";
import { PolyPerformanceformanceController } from "./poly/PerformanceController";
import { ScenesRegister } from "./poly/ScenesRegister";
import { LogoController } from "./poly/LogoController";
export class PolyEngine {
  constructor() {
    this.renderersController = new RenderersController();
    this.scenesRegister = new ScenesRegister();
    this.nodesRegister = new NodesRegister(this);
    this.operationsRegister = new OperationsRegister(this);
    this.expressionsRegister = new ExpressionRegister();
    this.assemblersRegister = new AssemblersRegister();
    this.pluginsRegister = new PluginsRegister(this);
    this.camerasRegister = new PolyCamerasRegister(this);
    this.blobs = new BlobsController(this);
    this.assetUrls = new AssetUrlsController();
    this.logo = new LogoController();
    this.performance = new PolyPerformanceformanceController();
    this.scenesByUuid = {};
    this._playerMode = true;
    this._logger = null;
  }
  static _instance_() {
    if (window.__POLYGONJS_POLY_INSTANCE__) {
      return window.__POLYGONJS_POLY_INSTANCE__;
    } else {
      const instance = new PolyEngine();
      window.__POLYGONJS_POLY_INSTANCE__ = instance;
      return window.__POLYGONJS_POLY_INSTANCE__;
    }
  }
  setPlayerMode(mode) {
    this._playerMode = mode;
  }
  playerMode() {
    return this._playerMode;
  }
  registerNode(node, tab_menu_category, options) {
    this.nodesRegister.register(node, tab_menu_category, options);
  }
  registerOperation(operation, options) {
    this.operationsRegister.register(operation, options);
  }
  registerCamera(cameraClass, viewerCreateCallback) {
    this.camerasRegister.register(cameraClass, viewerCreateCallback);
  }
  registerCameraNodeType(nodeType) {
    this.camerasRegister.registerNodeType(nodeType);
  }
  registerPlugin(plugin) {
    this.pluginsRegister.register(plugin);
  }
  wrapConfigurePolygonjs(callback) {
    this.pluginsRegister.wrapConfigurePolygonjs(callback);
  }
  registeredNodes(parentNode) {
    return this.nodesRegister.registeredNodes(parentNode);
  }
  registeredOperation(parent_context, operation_type) {
    return this.operationsRegister.registeredOperation(parent_context, operation_type);
  }
  inWorkerThread() {
    return false;
  }
  get libs() {
    return this._libs_controller = this._libs_controller || new PolyLibsController();
  }
  setEnv(env) {
    this._env = env;
  }
  env() {
    return this._env;
  }
  setLogger(logger) {
    this._logger = logger;
  }
  log(message, ...optionalParams) {
    var _a;
    (_a = this._logger) == null ? void 0 : _a.log(...[message, ...optionalParams]);
  }
  warn(message, ...optionalParams) {
    var _a;
    (_a = this._logger) == null ? void 0 : _a.warn(...[message, ...optionalParams]);
  }
  error(message, ...optionalParams) {
    var _a;
    (_a = this._logger) == null ? void 0 : _a.error(...[message, ...optionalParams]);
  }
}
export const Poly = PolyEngine._instance_();
